import { computed, observable } from 'mobx';
import {LinkedAccountI18n} from '../../../components/page-account-linked-accounts';

export class AccountPageModel {
  @observable
  loading: boolean = false;

  @observable
  i18n: {
    spotify: LinkedAccountI18n;
    twitter: LinkedAccountI18n;
    dropbox: LinkedAccountI18n;
    facebook: LinkedAccountI18n;
  };
}